// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = ./src/components/Footer/Footer.scss
// module chunks = 2